import {
  ChevronDownIcon,
  ExternalLinkIcon,
  ExitIcon
} from '@radix-ui/react-icons';
import { default as Button } from 'antd/es/button';
import { default as Spin } from 'antd/es/spin';
import { default as Select } from 'antd/es/select';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '../hooks/useUser';
import { goToCustomerApp } from '../utils/goToCustomerApp';

export function OrgDropDown() {
  const {
    availableOrganisations,
    currentOrganisation,
    setCurrentOrganisation,
    loading,
    logoutUser
  } = useUser();

  const organisationItems = useMemo(
    () =>
      availableOrganisations?.map((org) => {
        return { value: org.id.toString(), label: org.name };
      }) ?? [],
    [availableOrganisations]
  );

  if (loading) {
    return <Spin />;
  }

  if (!currentOrganisation) {
    return (
      <span
        onClick={() => goToCustomerApp()}
        className="super-round-inpay cursor-pointer border border-inpay-green-secondary-light-800 text-inpay-green-secondary-light-800 hover:bg-inpay-green-primary-800"
      >
        Log in
      </span>
    );
  }

  return (
    <Select
      className="org-select"
      size="large"
      options={organisationItems}
      value={currentOrganisation.id.toString()}
      onSelect={(selectedOrgId) => {
        if (availableOrganisations) {
          const newCurrentOrganisation = availableOrganisations.find(
            (org) => org.id.toString() === selectedOrgId
          );

          if (newCurrentOrganisation) {
            localStorage.setItem(
              'defaultOrg',
              newCurrentOrganisation.id.toString()
            );
            setCurrentOrganisation(newCurrentOrganisation);
          }
        }
      }}
      suffixIcon={<ChevronDownIcon width={20} height={20} color="#5BE695" />}
      dropdownRender={(menu) => (
        <>
          {menu}
          <Link to={window.location.origin} target="_blank">
            <Button
              className="w-full justify-between"
              type="text"
              iconPosition="end"
              icon={<ExternalLinkIcon />}
            >
              Customer App
            </Button>
          </Link>
          <Button
            className="w-full justify-between"
            type="text"
            iconPosition="end"
            icon={<ExitIcon />}
            onClick={() => logoutUser()}
          >
            Log out
          </Button>
        </>
      )}
    />
  );
}
